module.exports = __webpack_public_path__ + "media/images/about-us/PGA/Southern California PGA-c73a742d122a7ac3a528112feea52b8b.png";